import React, { Component } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { workoutProgramWithDescriptions } from 'fitbeat.gym-core';
import { IEnabledFeatures, ProgramType } from 'fitbeat.models';
import { mappedTitles, mappedIcons } from '../utils';
import { SelectWorkoutCard } from '../../Bookings/components';
import Theme from '../../theme';
import { connect } from 'react-redux';
import { enabledFeaturesSelector } from '../../auth';
import { TranslateProp } from '../../common-types';

class WorkoutProgramList extends Component<{
  t: TranslateProp;
  onPress: (programType: string) => void;
  longTermGoal?: string;
  useScrollView?: boolean;
  enabledFeatures: IEnabledFeatures;
}> {
  public selectWorkoutCardList = () => {
    const { t, onPress, longTermGoal, useScrollView = true, enabledFeatures } = this.props;
    return workoutProgramWithDescriptions(enabledFeatures)
      .filter(({ programType }) => programType !== ProgramType.NotSet)
      .map(({ programType, summary }) => {
        const isActive = programType !== ProgramType.NotSet && programType === longTermGoal;
        const activeTitle = isActive ? t('workoutGoals:active') : '';
        const title = mappedTitles[programType] + activeTitle;
        const iconColor = isActive ? Theme.PRIMARY : Theme.BLACK;
        const icon = mappedIcons[programType]({}, iconColor);
        return (
          <SelectWorkoutCard
            t={t}
            isMore
            isActive={isActive}
            key={programType}
            title={title}
            description={summary}
            icon={icon}
            onPress={() => onPress(programType)}
          />
        );
      });
  }

  public renderWithoutScrollView = () => {
    return (
      <View style={styles.container}>
        {this.selectWorkoutCardList()}
      </View>
    );
  }

  public renderWithScrollView = () => {
    return (
      <View style={styles.container}>
        <ScrollView contentContainerStyle={styles.scrollViewContainer}>
          {this.selectWorkoutCardList()}
        </ScrollView>
      </View>
    );
  }

  public render() {
    const { useScrollView = true } = this.props;
    return useScrollView ? this.renderWithScrollView() : this.renderWithoutScrollView();
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollViewContainer: {
    paddingTop: 10,
  },
});

const mapStateToProps = (state) => ({
  enabledFeatures: enabledFeaturesSelector(state),
});

export default connect(mapStateToProps)(WorkoutProgramList);
